export const firestoreTimeToMillis = (value: unknown): number => {
  if (!value) return 0
  if (value instanceof Date) return value.getTime()
  if (typeof (value as { toMillis?: () => number }).toMillis === 'function') {
    return (value as { toMillis: () => number }).toMillis()
  }
  if (typeof (value as { toDate?: () => Date }).toDate === 'function') {
    return (value as { toDate: () => Date }).toDate().getTime()
  }
  if (
    typeof value === 'object' &&
    value !== null &&
    'seconds' in value &&
    typeof (value as { seconds: unknown }).seconds === 'number'
  ) {
    const s = (value as { seconds: number }).seconds
    const ns =
      'nanoseconds' in value && typeof (value as { nanoseconds: unknown }).nanoseconds === 'number'
        ? (value as { nanoseconds: number }).nanoseconds
        : 0
    return s * 1000 + Math.floor(ns / 1e6)
  }
  const parsed = new Date(value as string).getTime()
  return Number.isNaN(parsed) ? 0 : parsed
}
